export const getOccupancyEp = ()=>{
    return ("/api/occupancy")
}

